import { useTranslation } from 'react-i18next';

import { Routes } from 'config';
import { useAppSelector } from 'store';
import { AccentMaskIcon } from 'components/icons';
import { selectAuthUser } from 'store/slices/auth';

import { ResponsiveMenuProps } from './types';
import { NavigationLink } from './navigation-link';
import { LanguageButton } from './language-button';

export const ResponsiveMenu = ({
  links,
  onClick,
  pathname,
  isGuestUser,
}: ResponsiveMenuProps) => {
  const { t } = useTranslation(['header']);
  const user = useAppSelector(selectAuthUser);

  return (
    <div className="absolute top-0 left-0 flex h-screen w-full pt-12 md:pt-16">
      <div className="bg-white-primary md:shadow-primary flex max-h-full min-h-0 w-full flex-col overflow-y-auto py-2 max-md:shadow-[inset_0_8px_16px_-8px_rgba(0,0,0,0.04)] md:-mt-6 md:self-start md:rounded-b-3xl md:py-6 md:pb-0">
        <div className="divide-gray-primary flex flex-col divide-y">
          {links?.map((item) => (
            <NavigationLink
              key={item.href}
              href={item.href}
              variant="mobile"
              onClick={onClick}
              label={t(item.i18nKey)}
              isActive={pathname === item.href}
            />
          ))}
          {!isGuestUser && user && (
            <NavigationLink
              isActive
              variant="mobile"
              onClick={onClick}
              href={Routes.Profile.Home}
              label={`${user.firstName} ${user.lastName}`}
              icon={
                <AccentMaskIcon className="h-6 w-6" src="/images/user.svg" />
              }
            />
          )}
          <LanguageButton buttonClassName="h-[54px] px-4 md:px-6" />
        </div>
      </div>
    </div>
  );
};
